// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import { spacing, zIndexes } from 'frontend_core/dist/styles/variables'
import { clearFix } from 'components/styles/helpers'
import ScrollControlView from 'components/atoms/ScrollControlView'
import Tab from 'components/atoms/Tab'

export const reservationSidebarWidth = 370
export const reservationSidebarWidthTb = 320

const WithsidebarWrapper = styled.div`
  ${clearFix()};
`
const SidebarWrapper = styled.div`
  position: static;
  ${mediaMax.phone`
    display: ${props => (props.isShowContentsSp ? 'none' : 'block')};
  `};
  ${mediaMin.phone`
    width: ${reservationSidebarWidthTb}px;
    float: left;
    position: fixed;
  `};
  ${mediaMin.desktop`
    width: ${reservationSidebarWidth}px;
    float: left;
  `};
`
const SidebarContent = styled.div`
  position: static;
  ${mediaMin.phone`
    position: fixed;
  `};
`
const MainContents = styled.div`
  width: 100%;
  padding: ${spacing.large}px 0;
  ${mediaMax.phone`
    display: ${props => (props.isShowContentsSp ? 'block' : 'none')};
  `};
  ${mediaMin.phone`
    max-width: 600px;
    padding: ${spacing.huge}px 0;
  `};
`
const MainWrapper = styled.div`
  width: 100%;
  ${mediaMin.phone`
    padding-left: ${reservationSidebarWidthTb}px;
    float: left;
  `};
  ${mediaMin.desktop`
    padding-left: ${reservationSidebarWidth}px;
  `};
`
const MainContentsWrapper = styled.div`
  padding: 0 ${spacing.medium}px;
  background-color: ${Colors.white};
  ${mediaMin.phone`
    padding: 0 ${spacing.medium_3}px;
  `};
  ${mediaMin.desktop`
    padding: 0 ${spacing.huge}px;
  `};
`
const FixedTabSp = styled.div`
  display: ${props => (props.isShow ? 'block' : 'none')};
  ${mediaMin.phone`
    display: none;
  `};
`
const TabSpHeight = 49
const BackLinkHeight = 38
const HeaderHeight = 48
const HeaderSpHeight = 58

const TabWrapperSp = styled.div`
  position: fixed;
  width: 100%;
  height: ${TabSpHeight}px;
  z-index: ${zIndexes.nav};
`
const TabWrapperSpBase = styled.div`
  height: ${TabSpHeight}px;
  ${mediaMin.phone`
    display: none;
  `};
`

type PropTypes = {
  isShowingModal?: ?boolean,
  isShowFixedTabSp?: ?boolean,
  children?: ?any,
  sidebarInbox?: ?any,
  isShowContentsSp: boolean,
  onClickDetailTab?: Function,
  onClickMessageTab?: Function,
}
export default (props: PropTypes) => (
  <ScrollControlView isLock={props.isShowingModal}>
    <WithsidebarWrapper>
      <FixedTabSp isShow={props.isShowFixedTabSp}>
        <TabWrapperSp>
          <Tab
            tabList={[
              {
                label: i18n.t('page.dashboard.reservation.reservationDetails'),
                current: !props.isShowContentsSp,
                onClick: props.onClickDetailTab,
              },
              {
                label: i18n.t('page.dashboard.reservation.message'),
                current: props.isShowContentsSp,
                onClick: props.onClickMessageTab,
              },
            ]}
          />
        </TabWrapperSp>
        <TabWrapperSpBase />
      </FixedTabSp>
      {props.sidebarInbox && (
        <SidebarWrapper isShowContentsSp={props.isShowContentsSp}>
          {props.sidebarInbox}
        </SidebarWrapper>
      )}
      <MainWrapper>
        <MainContentsWrapper>
          <MainContents isShowContentsSp={props.isShowContentsSp}>
            {props.children}
          </MainContents>
        </MainContentsWrapper>
      </MainWrapper>
    </WithsidebarWrapper>
  </ScrollControlView>
)



// WEBPACK FOOTER //
// ./src/components/templates/MainContentsWithSidebarInbox/index.jsx